import { Redirect } from 'expo-router';

export default function AboutNativeScreen() {
  return <Redirect href="/" />;
}
